import { render } from "./정신건강의학과.vue?vue&type=template&id=1e00deea"
import script from "./정신건강의학과.vue?vue&type=script&lang=js"
export * from "./정신건강의학과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__